export default "__VITE_ASSET__BHApmfO6__"